import { ActionReducer } from '@ngrx/store';
import { AuthSessionActions } from '@ps/auth-data-access';

export function stateResetMetaReducer<S>(
  reducer: ActionReducer<S>,
): ActionReducer<S> {
  return (state, action) => {
    if (action.type === AuthSessionActions.clearState.type) {
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}
